export default {
  data: () => ({
    loadedImages: []
  }),
  methods: {
    imageIsLoaded (img) {
      return this.loadedImages.includes(img)
    },
    fadeIn (key) {
      return {
        backgroundImage: `url(${this.images[key]})`,
        transition: 'opacity 500ms cubic-bezier(0.0, 0.0, 0.2, 1)',
        opacity: this.imageIsLoaded(this.images[key]) ? 1 : 0
      }
    }
  },
  watch: {
    images: {
      handler (val) {
        this.loadedImages = []
        Object.keys(val).forEach(key => {
          const img = new Image()
          img.src = val[key]
          img.onload = () => {
            this.loadedImages.push(val[key])
          }
        })
      },
      immediate: true
    }
  }
}
